<script>
export default {
    name: "LabInvestigation",

    data() {

        return {
            results: {},
            imageResults: [],
        };
    },

    props: {

        labInvestigations: {
            type: Array,
            required: true,
        },
    },

    components: {

        "lab-investigation-view": () => import('@/components/commons/medical-file/investigations/LabResults.vue'),
    },

    methods: {

        fetchComponentResults(inv) {
            let url = `MedicalFile/GetPatientLabResultforInvestigation`;
                url += `?PatientLabResultID=${inv.code}`;

            return this.$http.get(url).then(response => {
                this.results = response.data;
            }).catch(() => {});
        },

        fetchImages(inv) {
            let url = `Lab/GetLabInvestigationImageList`;
                url += `?PatientID=${this.$route.params.patientID}`;
                url += `&PatientLabResultId=${inv.code}`;

            return this.$http.get(url).then(response => {
                this.imageResults = response.data;
            }).catch(() => {});
        },

        fetchResults(inv) {
            this.$root.loading=true;
            return Promise.allSettled([ 
                    this.fetchComponentResults(inv), this.fetchImages(inv)
                ]).then(() => {
                    inv.view=true;
                    this.$root.loading=false;
                }).catch(() => { this.$root.loading=false; });
        },

        printMedicalFile() {
            window.print();
        },

        printRequests() {
          let url = `/medical-file/lab-requests/print`;
          url += `/${this.$route.params.patientID}/${this.$route.params.visitNo}`;

          window.open(
            url,
            "_blank",
            `LabRequestPrint`,
          );
        },

        printAllRequests() {
          let url = `/medical-file/lab-pending-requests/print`;
          url += `/${this.$route.params.patientID}/${this.$route.params.visitNo}`;

          window.open(
            url,
            "_blank",
            `LabRequestsPrint`,
          );
        },

        printRequest(code) {
            let url = `/medical-file/lab-pending-request/print/${this.$route.params.patientID}/${code}`;

          window.open(url, "_blank",  `LabRequestPrint`,);
        }
    },
}
</script>
<template>
<div class="w-full flex flex-wrap mt-1">
    <div class="w-full p-1 my-1">
        <div class="p-1 w-full flex flex-wrap bg-indigo-300 rounded-t-md">
            <div class="flex-1">
                <h5 class="font-bold text-white text-sm">Visit #{{ $route.query.visitNo }}</h5>
            </div>
            <div class="flex-1">
                <router-link 
                    class="btn-sm text-xs btn-primary ml-4"
                    :to="{ 
                            name: `lab.previous-results.view`, 
                            params: { patientID: $route.params.patientID, },
                            query: { from: $route.path, }
                        }">
                            <i class="fa fa-list"></i> Lab Test History
                </router-link>
            </div>
        </div>
        <div class="w-full bg-gray-100 border-r-2 border-l-2 border-b-2 border-indigo-300 rounded-b p-2">
            <table class="table">
                <thead class="bg-blue-500 text-white text-sm">
                    <tr>
                        <th class="p-tiny">Id</th>
                        <th class="p-tiny">Visit No</th>
                        <th class="p-tiny">Encounter</th>
                        <th class="p-tiny">Investigation</th>
                        <th class="p-tiny">Requested By</th>
                        <th class="p-tiny">Req Date</th>
                        <th class="p-tiny">Status</th>
                        <th class="p-tiny">Progress</th>
                        <th class="p-tiny">Date Done</th>
                        <th class="p-tiny">Done By</th>
                        <th class="p-tiny hide--print">Action</th>
                    </tr>
                </thead>
                <tbody class="text-xs bg-gray-100">
                    <tr v-for="(investigation,idx) in labInvestigations" :key="idx">
                        <td class="p-tiny">{{ investigation.code }}</td>
                        <td class="p-tiny">{{ investigation.visitNo }}</td>
                        <td class="p-tiny">{{ investigation.encounterID || '-' }}</td>
                        <td class="p-tiny">{{ investigation.investigation }}</td>
                        <td class="p-tiny">{{ investigation.requestedBy || investigation.userName}}</td>
                        <td class="p-tiny">{{ investigation.date | dateFormat }}</td>
                        <td class="p-tiny">{{ investigation.done ? `Done` : `Not Done` }}</td>
                        <td class="p-tiny">{{ investigation.progress || `-` }}</td>
                        <td class="p-tiny">{{ investigation.doneOn | dateFormat }}</td>
                        <td class="p-tiny">{{ investigation.recordedBy }}</td>
                        <td class="p-tiny hide--print">
                            <button 
                                @click.prevent="() => {
                                    fetchResults(investigation).then(() => { 
                                        investigation.view=true; 
                                    });
                                }"
                                class="btn-sm btn-info text-xs rounded m-px">
                                    <i class="fa fa-eye"></i> View</button>
                            <button 
                                v-if="!investigation.done"
                                @click.prevent="printRequest(investigation.code)"
                                class="btn-sm btn-primary text-xs rounded m-px">
                                    <i class="fa fa-print"></i> Print</button>
                            <router-link
                                  v-if="
                                        ($root.formatLowercase(investigation.userName) ==
                                        $root.formatLowercase($root.username)) ||
                                        $root.checkAuth('AdminEditMedicalFile')
                                      " 
                                  :to="{
                                    name: `med-f.visit.index`,
                                    params: {
                                      patientID: $route.params.patientID,
                                      visitNo: $route.params.visitNo,
                                    },
                                    query: {
                                      encounterID: investigation.encounterID,
                                      from: $route.query.from,
                                    },
                                  }" 
                                  class="btn-sm btn-warning text-xs text-white rounded m-px hide--print">
                                <i class="fa fa-times"></i> Cancel
                            </router-link>
                            <lab-investigation-view 
                                :investigation="investigation"
                                :results="results"
                                :imageResults="imageResults"
                                :routeParams="{ 
                                    patientID: $route.params.patientID,
                                    visitNO: investigation.visitNo,
                                }"
                                :showModal="investigation.view"
                                @closeModal="investigation.view=false"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="w-full p-1 text-right">
        <button 
            @click.prevent="printRequests"
            class="btn-sm btn-primary text-xs hide--print mr-4">
                <i class="fa fa-print"></i> Print</button>
        <button 
            @click.prevent="printAllRequests"
            class="btn-sm btn-info text-xs hide--print">
                <i class="fa fa-print"></i> Pending Requests</button>
    </div>
</div>
</template>
<style scoped>
    @media print {
        .hide--print {
            display: none;
        }
    }
</style>
